// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_6b-2";
export var blackBorderOnHover = "_6b-7";
export var cell = "_6b-6";
export var cellContainer = "_6b-3";
export var checked = "_6b-8";
export var disabled = "_6b-5";
export var featuredIconCellContainer = "_6b-9";
export var featuredIconTextContainer = "_6b-b";
export var featuredIconWrapper = "_6b-a";
export var noBorder = "_6b-c";
export var orangeSelectedRow = "_f8-3";
export var overflowableText = "_6b-0";
export var overflowableTextContainer = "_6b-1";
export var row = "_6a-0";
export var rowCheckboxCell = "_6b-4";
export var selectableTable = "_f8-2";